import { notification, Space } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import React, { useEffect, useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';

import {
  fetchJobAuditDataByJobId,
  GetSessionJobDetails
} from '../../../Apis/Facility';
import { getDataOfPatient } from '../../../Apis/Patient';
import { formatDate, formatDateTime } from '../../../Utils/dateFormat';
import CustomAvatar from '../../CustomComponents/CustomAvatar';
import JobDetails from './JobDetails';
import {
  SessionInfoContainer,
  InformationText,
  InformationTitle,
  UserInfoContainer,
  InfoContainer,
  UserInfoRow,
  DemographicsContainer,
  AuditInfoContainer,
  SessionInfoOneContainer,
  SessionInfotoOneContainer
} from './styledComponents';
import {
  sectionFetch,
  getDemographics,
  getJobInfoForPrint
} from '../../../Apis/Jobs';
import Spinner from '../../CustomComponents/Spinner';
import { SectionTag, SuppressLine } from './AuditDetailStyles';
const SessionDetails = forwardRef((props, ref) => {
  const [theme] = useSelector(state => [state.themeReducer]);
  const [loading, setLoading] = useState(false);
  const [scrollLoading, setScrollLoading] = useState(false);
  const [jobData, setJobData] = useState([]);
  const [sections, setSections] = useState([]);
  const [patientInfoData, setPatientInfoData] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [aiGenerations, setAiGenerations] = useState([]);
  const userString = localStorage.getItem('user');
  const userType = userString ? JSON.parse(userString) : null;
  const [localDemographicsData, setLocalDemographicsData] = useState([]);
  // const [demographicsData, setDemographicsData] = useState([]);
  const [demographicsData, setDemographicsData] = useState({ result: [] });
  const userData = JSON.parse(localStorage.getItem('user'));

  // Tracks when all three fetch groups (audit data, demographics+patient, sections)
  // have settled so ReportPdf knows it's safe to snapshot the DOM.
  const [pdfReady, setPdfReady] = useState(false);
  const pendingRef = React.useRef(0);
  const onFetchDone = () => {
    pendingRef.current -= 1;
    if (pendingRef.current === 0) setPdfReady(true);
  };

  const getSessionJobDetails = pageNo => {
    if (pageNo === 0) {
      setLoading(true);
    } else {
      setScrollLoading(true);
    }
    if (props.selectedTab === 2) {
      GetSessionJobDetails(props.session.id, pageNo, 13, props.searchValue)
        .then(response => {
          if (response.data.success) {
            let newList = [];
            if (pageNo === 0) {
              newList = response.data.result;
            } else {
              newList = jobData.concat(response.data.result);
            }
            setJobData(newList);
            setHasMore(response.data.result.length > 12);
            setLoading(false);
            setScrollLoading(false);
          } else {
            notification['error']({
              message: 'Payment Profile Fetch Failed',
              description: response.data.message
            });
            setLoading(false);
            setScrollLoading(false);
          }
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
          setScrollLoading(false);
        });
    } else {
      // Three independent fetch groups fire below; count them down.
      setPdfReady(false);
      pendingRef.current = 3;

      fetchJobAuditDataByJobId(props.session.jobId)
        .then(response => {
          if (response.data.success) {
            let newList = [];
            if (pageNo === 0) {
              newList = response.data.result;
            } else {
              newList = jobData.concat(response.data.result);
            }
            setJobData(newList);
            setAiGenerations(response.data.aiJobSectionGenerations || []);
            setHasMore(false);
            setLoading(false);
            setScrollLoading(false);
          } else {
            notification['error']({
              message: 'Payment Profile Fetch Failed',
              description: response.data.message
            });
            setLoading(false);
            setScrollLoading(false);
          }
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
          setScrollLoading(false);
        })
        .finally(onFetchDone);

      getJobInfoForPrint(props.session.jobId)
        .then(response => {
          if (response.data.success === true) {
            setLocalDemographicsData(response.data.result);
            getDataOfPatient(
              response.data.result[0].facility.facilityId,
              response.data.result[0].patientId
            )
              .then(response => {
                if (response.data.success) {
                  setPatientInfoData(response.data.result);
                } else {
                  notification['error']({
                    message: 'Failed',
                    description: response.data.message
                  });
                }
              })
              .catch(err => {
                console.log(err);
              })
              .finally(onFetchDone);
          } else {
            notification['error']({
              message: 'Demographics Fetch Failed',
              description: response.data.message
            });
            // getDataOfPatient will never run; count it as done.
            onFetchDone();
          }
          // setDemographicsLoading(false);
          // setRefetchDemographics(false);
        })
        .catch(err => {
          // setDemographicsLoading(false);
          // setRefetchDemographics(false);
          console.log(err);
          // setDemographicsLoading(false);
          // getDataOfPatient will never run; count it as done.
          onFetchDone();
        });
      sectionFetch(props.session.jobId)
        .then(response => {
          if (response.data.success) {
            for (let i = 0; i < response.data.result.length; i++) {
              const resultItem = response.data.result[i];

              for (let j = 0; j < resultItem.sections.length; j++) {
                const section = resultItem.sections[j];
                for (let k = 0; k < section.content.length; k++) {
                  const contentItem = section.content[k];
                  if (contentItem.type === 'Text') {
                    response.data.result[i].sections[j].content[k].value =
                      processValue(contentItem.value);
                  }
                }
              }
            }

            setSections(
              response.data.result[0] && response.data.result[0].sections
            );

            // setDectationTemplates(response.data.templates);
            // setEditorDataPreviewValue(
            //   response.data.result[0] && response.data.result[0].sections
            // );
            // setCurrentTime(response.data.result[0].audioTime);
          } else {
            notification['error']({
              message: 'Section Fetch Failed',
              description: response.data.message
            });
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(onFetchDone);
    }
  };
  function processValue(value) {
    return value
      .replace(/<p>/g, '')
      .replace(/<\/p>/g, '')
      .replace(/<\/?(ol|ul|li)>/g, '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/(\r\n|\r|\n)/g, '\n');
    // .replace(/\n\s*\d+\.\s*/g, '\n'); // Remove numbered list formatting;`
    // .replace(/<(?!\/?(b|i|s|u)\b)[^>]*>/g, '');
  }

  const getPageMargins = () => {
    return `
 @media print {
      @page {
        margin: 2cm 1.5cm;
      }

      body {
        counter-reset: page;
      }

      .page::after {
        counter-increment: page;
        content: "Page " counter(page);
        position: fixed;
        bottom: 1cm;
        right: 1.5cm;
        font-size: 12px;
        color: #444;
      }

      .custom-header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        padding-top: 10px;
      }

      .content {
        margin-top: 60px; /* pushes content below fixed header */
      }
    }
    `;
  };
  useEffect(() => {
    if (props.session) getSessionJobDetails(0);

    // eslint-disable-next-line
  }, [props.session]);

  return (
    props.session && (
      <div ref={ref} data-pdf-ready={pdfReady ? 'true' : undefined}>
        <style>{getPageMargins()}</style>

        {/* Custom Print Header */}

        {loading ? (
          <Spinner height={'50vh'} />
        ) : (
          <>
            {!props.hideDemographicsHeader && (
              <div style={{ textAlign: 'center', marginBottom: '2px' }}>
                <h2
                  style={{
                    fontWeight: 'bold'
                  }}
                >
                  Patient Report{' '}
                </h2>
                <p>{props.session.jobNumber}</p>
              </div>
            )}

            <SessionInfoOneContainer>
              <SessionInfotoOneContainer>
                {props.selectedTab === 2 && (
                  <UserInfoContainer>
                    <Space>
                      <CustomAvatar url={props.session.profilePic} size={30} />
                      <InformationText
                        color={theme['@table-text-color']}
                        name={true}
                      >
                        {props.session.fullName}
                      </InformationText>
                    </Space>
                  </UserInfoContainer>
                )}
                {props.selectedTab === 2 && (
                  <UserInfoRow>
                    <InfoContainer>
                      <InformationTitle color={theme['@text-color']}>
                        Email&nbsp;&nbsp;
                      </InformationTitle>
                      <InformationText color={theme['@table-text-color']}>
                        {props.session.email}
                      </InformationText>
                    </InfoContainer>
                    <InfoContainer>
                      <InformationTitle color={theme['@text-color']}>
                        {props.selectedTab === 2 ? 'IP Address' : ''}
                        &nbsp;&nbsp;
                      </InformationTitle>
                      {/* <InformationText color={theme['@table-text-color']}>
                  {props.selectedTab === 1
                    ? props.session.loggedUserIp
                    : `${Math.floor(
                        moment.duration(props.session.tat).asHours()
                      )} H`}
                </InformationText> */}
                    </InfoContainer>
                  </UserInfoRow>
                )}
                <UserInfoRow>
                  {/* <InfoContainer>
                  {/* <InformationTitle color={theme['@text-color']}>
                    {props.selectedTab === 1 ? 'Start Time' : 'Audio Length'}
                    &nbsp;&nbsp;
                  </InformationTitle>
                  <InformationText color={theme['@table-text-color']}>
                    {props.selectedTab === 1
                      ? formatDateTime(props.session.loginTime)
                      : props.session.audioLength}
                  </InformationText>
                </InfoContainer> */}
                  {props.selectedTab === 2 && (
                    <InfoContainer>
                      <InformationTitle color={theme['@text-color']}>
                        Start Time&nbsp;&nbsp;
                      </InformationTitle>
                      <InformationText color={theme['@table-text-color']}>
                        {formatDateTime(props.session.loginTime)}
                      </InformationText>
                    </InfoContainer>
                  )}
                  {props.selectedTab === 2 && (
                    <InfoContainer>
                      <InformationTitle color={theme['@text-color']}>
                        End Time &nbsp;&nbsp;
                      </InformationTitle>
                      {/* <InformationText color={theme['@table-text-color']}>
                      {props.selectedTab === 1
                        ? props.session.logoutTime === 0
                          ? 'Active Session'
                          : formatDateTime(props.session.logoutTime)
                        : ''}
                    </InformationText> */}
                    </InfoContainer>
                  )}
                </UserInfoRow>
              </SessionInfotoOneContainer>
              {props.selectedTab === 1 && <UserInfoRow></UserInfoRow>}
              {props.selectedTab === 1 && !props.hideDemographicsHeader && localDemographicsData && (
                <DemographicsContainer>
                  <h3
                    style={{
                      fontWeight: 'bold',
                      fontSize: '1.2em',
                      marginBottom: '0.5em'
                    }}
                  >
                    Note Information
                  </h3>
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      border: '1px solid black'
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan='2'
                          style={{
                            borderTop: '1px solid black',
                            borderBottom: '1px solid black',
                            borderLeft: 'none',
                            borderRight: 'none',
                            padding: '3px',
                            fontWeight: 'bold'
                          }}
                        >
                          Author:{' '}
                          <span style={{ fontWeight: 'normal' }}>
                            {localDemographicsData[0]?.author}
                          </span>
                        </td>
                        <td
                          style={{ border: '1px solid black', padding: '3px' }}
                        >
                          <strong>Facility:</strong>{' '}
                          <span style={{ fontWeight: 'normal' }}>
                            {localDemographicsData[0]?.facility.facilityName}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: '1px solid black', padding: '3px' }}
                        >
                          <strong>Date of Encounter:</strong>{' '}
                          {localDemographicsData[0]?.effectiveDate
                            ? formatDateTime(
                                localDemographicsData[0].effectiveDate
                              )
                            : ''}
                        </td>
                        <td
                          style={{ border: '1px solid black', padding: '3px' }}
                        >
                          <strong>Note Type:</strong> {''}
                          {localDemographicsData[0]?.workType}
                        </td>
                        <td
                          style={{ border: '1px solid black', padding: '3px' }}
                        >
                          <strong>Job Number:</strong> {''}
                          {props.session.jobNumber}
                        </td>
                      </tr>
                      {props.session?.cptCodesInContent?.length > 0 && (
                        <tr>
                          <td
                            colSpan='3'
                            style={{
                              border: '1px solid black',
                              padding: '3px'
                            }}
                          >
                            <strong>CPT Code(s):</strong>{' '}
                            {props.session.cptCodesInContent
                              .map(c => c.cptCode)
                              .filter(Boolean)
                              .join(', ')}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <h3
                    style={{
                      fontWeight: 'bold',
                      fontSize: '1.2em',
                      marginBottom: '0px',
                      marginTop: 'opx'
                    }}
                  >
                    Patient Information
                  </h3>
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      border: '1px solid black'
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan='3'
                          style={{
                            borderTop: '1px solid black',
                            borderBottom: '1px solid black',
                            borderLeft: 'none',
                            borderRight: 'none',
                            padding: '3px',
                            fontWeight: 'bold'
                          }}
                        >
                          Patient Name:{' '}
                          <span style={{ fontWeight: 'normal' }}>
                            {localDemographicsData[0]?.patientName}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ border: '1px solid black', padding: '3px' }}
                        >
                          <strong>Date of Birth:</strong>{' '}
                          {patientInfoData[0]?.birthDate
                            ? formatDate(patientInfoData[0].birthDate)
                            : ''}
                        </td>
                        <td
                          style={{ border: '1px solid black', padding: '3px' }}
                        >
                          <strong>Date of Admission:</strong>{' '}
                          {patientInfoData[0]?.admissionDate
                            ? formatDate(patientInfoData[0].admissionDate)
                            : ''}
                        </td>
                        <td
                          style={{ border: '1px solid black', padding: '3px' }}
                        >
                          <strong>Room/Bed ID:</strong>{' '}
                          {patientInfoData[0]?.bedId}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan='3'
                          style={{ border: '1px solid black', padding: '3px' }}
                        >
                          <strong>Medical Record Number:</strong>{' '}
                          {patientInfoData[0]?.medicalRecordNumber}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </DemographicsContainer>
              )}
              {(props.printOption === 'audit' ||
                props.printOption === 'combined') && (
                <JobDetails
                  loading={loading}
                  jobData={jobData}
                  getSessionJobDetails={getSessionJobDetails}
                  hasMore={hasMore}
                  scrollLoading={scrollLoading}
                  sessionId={props.session.id}
                  selectedTab={props.selectedTab}
                  hideComment={!!props.hideDemographicsHeader}
                />
              )}
              {(props.printOption === 'note' ||
                props.printOption === 'combined') && (
                <AuditInfoContainer>
                  <div>
                    <h3
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'center'
                      }}
                    >
                      Note Content{' '}
                    </h3>
                    {(() => {
                      const aiHeadings = new Set(
                        aiGenerations.flatMap(item => {
                          const content =
                            item.request?.find(r => r.role === 'user')?.content ||
                            item.promptRequest ||
                            '';
                          const match = content.match(
                            /Generate content for the ["']([^"']+)["'] section/i
                          );
                          return match ? [match[1].trim().toUpperCase()] : [];
                        })
                      );
                      return sections.map((section, index) => {
                        const suppressed = section.heading?.submitToEmr === false;
                        const isAi = aiHeadings.has(
                          (section.heading?.customUIHeading || '').toUpperCase()
                        );
                        return (
                          <div
                            key={section.id || index}
                            style={{ marginBottom: 20 }}
                          >
                            <h2
                              style={{
                                fontSize: '13px',
                                fontWeight: 600,
                                color: '#1A2332',
                                margin: '0 0 9px',
                                padding: '0 0 6px 10px',
                                borderLeft: '3px solid #47A4EA',
                                borderBottom: '1px solid #E8ECF0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8
                              }}
                            >
                              <span>{section.heading.customUIHeading}</span>
                              {suppressed && (
                                <SectionTag suppressed>Suppressed</SectionTag>
                              )}
                              {isAi && (
                                <SectionTag ai>AI enabled section</SectionTag>
                              )}
                            </h2>
                          {suppressed && (
                            <SuppressLine>
                              <WarningOutlined style={{ marginTop: 1 }} />
                              Not submitted to the EHR. Retained for audit.
                            </SuppressLine>
                          )}
                          {section.content.map((contentItem, idx) => (
                            <div
                              key={idx}
                              className='ql-editor'
                              style={{
                                fontSize: '11.5px',
                                lineHeight: 1.58,
                                color: '#525E6F',
                                margin: 0,
                                padding: 0
                              }}
                              dangerouslySetInnerHTML={{
                                __html: contentItem.value
                              }}
                            />
                          ))}
                        </div>
                      );
                    });
                    })()}
                  </div>
                </AuditInfoContainer>
              )}
              {!props.hideAiGenerations && aiGenerations.length > 0 && (
                <AuditInfoContainer>
                  <h3
                    style={{
                      fontWeight: 'bold',
                      textAlign: 'center'
                    }}
                  >
                    AI enabled section Sections
                  </h3>
                  {aiGenerations.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: '1.5em',
                        border: '1px solid #d9d9d9',
                        borderRadius: '4px',
                        padding: '12px'
                      }}
                    >
                      <table
                        style={{
                          width: '100%',
                          borderCollapse: 'collapse',
                          marginBottom: '8px'
                        }}
                      >
                        <tbody>
                          <tr>
                            <td style={{ padding: '3px', width: '120px' }}>
                              <strong>Name:</strong>
                            </td>
                            <td style={{ padding: '3px' }}>{item.fullName}</td>
                            <td style={{ padding: '3px', width: '80px' }}>
                              <strong>Time:</strong>
                            </td>
                            <td style={{ padding: '3px' }}>
                              {formatDateTime(item.time)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div style={{ marginBottom: '6px' }}>
                        <strong>Prompt Request:</strong>
                        <p
                          style={{
                            whiteSpace: 'pre-wrap',
                            marginTop: '4px',
                            marginBottom: '0',
                            background: '#f5f5f5',
                            padding: '8px',
                            borderRadius: '3px',
                            fontSize: '13px'
                          }}
                        >
                          {item.request?.find(r => r.role === 'user')
                            ?.content || 'No prompt stored/available'}{' '}
                        </p>
                      </div>
                      <div>
                        <strong>Response:</strong>
                        <p
                          style={{
                            whiteSpace: 'pre-wrap',
                            marginTop: '4px',
                            marginBottom: '0',
                            background: '#f5f5f5',
                            padding: '8px',
                            borderRadius: '3px',
                            fontSize: '13px'
                          }}
                        >
                          {item.response}
                        </p>
                      </div>
                    </div>
                  ))}
                </AuditInfoContainer>
              )}
              {!props.hideAiGenerations && props.session?.mips && (
                <AuditInfoContainer>
                  <h3 style={{ fontWeight: 'bold', textAlign: 'center' }}>
                    MIPS Score Generation
                  </h3>
                  <div
                    style={{
                      marginBottom: '1.5em',
                      border: '1px solid #d9d9d9',
                      borderRadius: '4px',
                      padding: '12px'
                    }}
                  >
                    <table
                      style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginBottom: '8px'
                      }}
                    >
                      <tbody>
                        <tr>
                          <td style={{ padding: '3px', width: '120px' }}>
                            <strong>Name:</strong>
                          </td>
                          <td style={{ padding: '3px' }}>
                            {props.session.mips.fullName}
                          </td>
                          <td style={{ padding: '3px', width: '80px' }}>
                            <strong>Time:</strong>
                          </td>
                          <td style={{ padding: '3px' }}>
                            {formatDateTime(props.session.mips.timestamp)}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ padding: '3px' }}>
                            <strong>Score:</strong>
                          </td>
                          <td style={{ padding: '3px' }} colSpan={3}>
                            {props.session.mips.score}/100
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ marginBottom: '6px' }}>
                      <strong>Prompt:</strong>
                      <p
                        style={{
                          whiteSpace: 'pre-wrap',
                          marginTop: '4px',
                          marginBottom: '0',
                          background: '#f5f5f5',
                          padding: '8px',
                          borderRadius: '3px',
                          fontSize: '13px'
                        }}
                      >
                        {props.session.mips.prompt}
                      </p>
                    </div>
                    <div>
                      <strong>Suggestions:</strong>
                      <p
                        style={{
                          whiteSpace: 'pre-wrap',
                          marginTop: '4px',
                          marginBottom: '0',
                          background: '#f5f5f5',
                          padding: '8px',
                          borderRadius: '3px',
                          fontSize: '13px'
                        }}
                      >
                        {props.session.mips.suggestions}
                      </p>
                    </div>
                  </div>
                </AuditInfoContainer>
              )}
            </SessionInfoOneContainer>
          </>
        )}
      </div>
    )
  );
});

export default SessionDetails;
